export function SortIcon() {
  return (
    <path fill="currentColor" d="M3 18v-2h6v2zm0-5v-2h12v2zm0-5V6h18v2z"></path>
  )
}